import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4da83e63"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "mask"
};
const _hoisted_2 = {
  class: "popup"
};
const _hoisted_3 = {
  class: "popup-text"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-hr"
}, null, -1));
const _hoisted_6 = {
  class: "popup-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [$props.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "down"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString($props.text) + " ", 1), _createElementVNode("div", {
      class: _normalizeClass(["popup-warn", {
        isWarn: $props.warnActive == true
      }])
    }, [_hoisted_4, _createTextVNode(" " + _toDisplayString($props.warnText), 1)], 2)]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
      class: "popup-button-confirm",
      style: _normalizeStyle('color:' + $props.colorText),
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.confirmFun && $setup.confirmFun(...args))
    }, _toDisplayString($props.confirmText), 5), _createElementVNode("div", {
      class: "popup-button-cancle",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.cancelFun && $setup.cancelFun(...args))
    }, _toDisplayString($props.cancleText), 1)])])]),
    _: 1
  })])) : _createCommentVNode("", true)]);
}